module.exports = __webpack_public_path__ + "static/media/i.270941de.svg";